import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

/**
 * This component was created to allow internal children of a parent with external
 * padding (example: `ExerciseComponent`) to overflow into it using negative margins.
 *
 *
 * The wrapped component that needs to overflowing into parent.
 * @property {node} children
 * The background-color for the parent
 * @property {String} backgroundColor
 * The background color property from Styled System
 * @property {String} bg
 */
const OverflowContainer = styled.div`
    ${({ backgroundColor, bg, theme }) => css`
        border-radius: ${theme.space.xs}px;
        background-color: ${theme.colors[backgroundColor || bg || 'surface-grey-050']};

        margin-left: -${theme.space.mobile}px;
        margin-right: -${theme.space.mobile}px;

        ${theme.mediaQueries.tablet} {
            margin-left: -${theme.space.tablet}px;
            margin-right: -${theme.space.tablet}px;
        }
        ${theme.mediaQueries.desktop} {
            margin-left: 0;
            margin-right: 0;
        }
    `}
`;

OverflowContainer.propTypes = {
    children: PropTypes.node,
    backgroundColor: PropTypes.string,
    bg: PropTypes.string,
};

export default OverflowContainer;
